import {
  CampaignActivityAction,
  type CampaignActivityLog,
  STAGE_TRANSITION_CAUSES,
  type StageTransitionCause,
} from "@/marketing/models/campaignActivity";

const CAUSE_LABELS = {
  [STAGE_TRANSITION_CAUSES.Manual]: "Moved manually",
  [STAGE_TRANSITION_CAUSES.CreatorConfirmedShipping]:
    "Creator confirmed shipping",
  [STAGE_TRANSITION_CAUSES.MarketingOrderShipped]: "Marketing order shipped",
  [STAGE_TRANSITION_CAUSES.MarketingOrderDelivered]: "Carrier delivered",
  [STAGE_TRANSITION_CAUSES.ContentSubmitted]: "Creator submitted content",
  [STAGE_TRANSITION_CAUSES.AffiliateCodeIssued]: "Affiliate code issued",
  [STAGE_TRANSITION_CAUSES.BrandPick]: "Brand picked in Business Portal",
} satisfies Record<StageTransitionCause, string>;

function isKnownCause(cause: string): cause is StageTransitionCause {
  return Object.prototype.hasOwnProperty.call(CAUSE_LABELS, cause);
}

// Transitions logged before causes were recorded carry none, so they get no label.
export function getStageTransitionCauseLabel(
  entry: CampaignActivityLog,
): string | undefined {
  if (entry.action !== CampaignActivityAction.StageTransition) return undefined;
  const cause = entry.payload?.["cause"];
  if (typeof cause !== "string") return undefined;
  return isKnownCause(cause) ? CAUSE_LABELS[cause] : cause;
}
